import type { CoreContextType } from "PFCore/core_context";
import { CurrentAccount } from "PFTypes";

export const getAccountDateFormatData = (
  currentAccount: CurrentAccount
): Partial<Pick<CoreContextType, "dateFormat" | "isAM">> => {
  if (!currentAccount) {
    return {};
  } else {
    const { customization } = currentAccount;
    const { displayDateFormat: dateFormat, twelveHourClock: isAM } = customization || {};
    return { dateFormat, isAM };
  }
};
